import type { PayEncounterPayments } from 'features/Procedure/state/procedure-api.type'

import { roundCurrency } from '../checkout.utils'

export type CheckoutManualCard = {
  token: string
  amount: number
  last4: string
  brand: string
}

export type CheckoutOtherPayment = {
  amount: number
  reference: string
}

export const buildCheckoutPayments = ({
  cards,
  other,
}: {
  cards: CheckoutManualCard[]
  other: CheckoutOtherPayment | null
}): PayEncounterPayments => {
  const cc = cards
    .filter((entry) => entry.amount > 0)
    .map((entry) => ({
      amount: roundCurrency(entry.amount),
      reference: `STRIPE:${entry.token}`,
      card_last_four: entry.last4,
      card_type: (entry.brand || '').toUpperCase(),
      authorization_code: entry.token,
    }))

  return {
    cc,
    ...(other && other.amount > 0
      ? { other: { amount: roundCurrency(other.amount), reference: other.reference.trim() } }
      : {}),
  }
}
